module.exports = __webpack_public_path__ + "static/NGLogo-c08660191c4bfd1e5cd614fe41562026.png";